import {AppButtonIcon} from "@components"
import {REAL_TIME_ROUTES} from "@constants"
import {Box, Divider, Typography} from "@mui/material"
import React from "react"


export default function diffColumn() {

	return {
		name: "priceDiff",
		label: "Diff",
		options: {
			customBodyRowRenderLite: (diff, { idSearch }) => {
				return <Box sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
				}}>
					{ !!diff && <>
						<Typography sx={{ textAlign: "center" }}>{diff}%</Typography>
						<Divider sx={{
							my: 1,
							width: "80%",
							borderBottom: "2px solid",
							borderColor: "secondary.lighter",
						}}/>
					</>}
					<AppButtonIcon
						sx={{
							width: "1.8rem",
							height: "1.8rem",
							border: "none",
							color: "primary.main",
							mt: 0.5,
							fontSize: "1.8rem",
							"&:hover": {
								border: "none",
							},
						}}
						icon="magnifying-glass-chart"
						onClick={e => {
							window.open(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${idSearch}`)
							if (e.ctrlKey) e.preventDefault()
						}}
						tooltip="View in real time searches"
					/>
				</Box>
			},
		},
	}
}